/**
 * `/casos/:id/abertura` na área do perito — o endereço dos passos de antes (E126.F2–F4). Desde a
 * E144.F3 (GUS-135) a abertura é uma jornada só, em `/casos/novo?caso=&passo=`: o link já salvo
 * leva ao mesmo lugar (Arquivos e Custódia viraram parte do Enviar; o resumo, Acompanhar).
 */
import { Navigate, useParams, useSearchParams } from 'react-router-dom';

import { passoDaUrl } from '@/lib/abertura';

export function AberturaEletronicaPage(): JSX.Element {
  const { id: caseId = '' } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const passo = passoDaUrl(searchParams.get('passo'));
  return <Navigate to={`/casos/novo?caso=${caseId}&passo=${passo}`} replace />;
}
